import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Subject } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from "src/app/services/util.service";
import { UserCardConfig } from "src/app/types/UserCardConfig";
import Swal from "sweetalert2";
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { WidgetModule } from '../../../widget/widget.module';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-team-invite-sent",
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, CommonSkeletonComponent, WidgetModule, UserCardComponent, NodataFoundComponent, InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./team-invite-sent.component.html",
  styleUrls: ["./team-invite-sent.component.scss"],
})
export class TeamInviteSentComponent implements OnInit {
  pathdata;
  inviteLength;
  ownerFlag: boolean = false;
  membersData: any = [];
  userCardConfig: UserCardConfig[] = [];
  commonVariables: any = {};
  showNoDatafound: boolean = false;
  loadAPIcall:boolean=false
  noDatafound : Array<string> = ["You have no invitations sent lately"];
  searchKey
  stopScroll: boolean = false;
  previouseAfterKey: any = null;
  searchSubject = new Subject<string>();
  scrollSubject = new BehaviorSubject<string>(null);
  loadScroll: boolean;
  invitePayload = {
    teamId: null,
    limit: 10,
    searchAfterKey: null,
    searchContent: null,
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private SearchData: SearchData,
    private api: ApiService,
    private util: UtilService
  ) {}

  ngOnInit() {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.queryParams.subscribe((res) => {
     // //// console.log("this is query params sent");
     // //// console.log(res);
      this.pathdata = res;
      if (res.teamId == undefined) {
        // this.pathdata.teamId = null;
      }
      if (localStorage.getItem("userId") == this.pathdata.teamsOwnerId) {
        this.ownerFlag = true;
        let revokeBtn: UserCardConfig = new UserCardConfig(
          "Cancel Invitation",
          this.cancelInvite,
          this.canShow,
          true
        );
        revokeBtn.source = this;
        this.userCardConfig.push(revokeBtn);
      } else {
        this.ownerFlag = false;
      }
    });
    // if (this.pathdata.teamId != "") {
    this.getInviteList();
    // }

    this.searchSubject.pipe(
      debounceTime(500),
      map((res: string) => (res || '').trim().replace(/\s+/g, ' ')),
      distinctUntilChanged()
    ).subscribe(res => {
      if (res === (this.invitePayload.searchContent || '')) { return; } // skip whitespace-only / unchanged searches
      this.loadScroll = false;
      this.resetPayload();
      this.invitePayload.searchContent = res || null;
      this.getInviteList();
    });

    this.scrollSubject.pipe(
      debounceTime(100),
      distinctUntilChanged()
    ).subscribe(res => {
      if (res != null) {
        this.invitePayload.searchAfterKey = this.previouseAfterKey;
        this.getInviteList();
      }
    })
  }
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }
  resetPayload() {
    this.membersData = [];
    this.invitePayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
  }

  getInviteList() {
    this.loadAPIcall = true;
    this.invitePayload.teamId = this.pathdata.teamId;
    const requestSearchContent = this.invitePayload.searchContent;
    this.api.create("teams/member/invites/find", this.invitePayload).subscribe((res) => {
      this.loadAPIcall = false;
      this.loadScroll = false;
      if (requestSearchContent !== this.invitePayload.searchContent) { return; } // stale: search mode changed mid-flight
      if (res.code === GigsumoConstants.SUCESSCODE) {

        const current = res.data.TeamsMember || [];
        const searchAfterKey = res.data.searchAfterKey;

        if (current.length === 0 || JSON.stringify(this.previouseAfterKey) === JSON.stringify(searchAfterKey)) {
          this.stopScroll = true;
        }

        current.forEach(element => {
          element.userName = element.firstName + " " + element.lastName;
        });

        const existingMemberIds = new Set(this.membersData.map(member => member.teamMemberId));
        const newMembers = current.filter(member => !existingMemberIds.has(member.teamMemberId));
        this.membersData = [...this.membersData, ...newMembers];

        this.previouseAfterKey = searchAfterKey;
        this.inviteLength = res.data.total ?? this.membersData.length;

        if (!this.invitePayload.searchContent) { // badge shows the full pending count, not search matches
          this.commonVariables.pendingCount = this.inviteLength;
          this.SearchData.setCommonVariables(this.commonVariables);
        }
      }
    }, err => {
      this.loadAPIcall = false;
      this.loadScroll = false;
      this.util.stopLoader();
    });
  }

  onSearchInvite(v: string) {
    this.searchSubject.next(v);
  }

  onScrollDown() {
    if (!this.stopScroll) {
      this.loadScroll = true;
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }
  cancelInvite(data) {
    const obj: any = {};
    obj.teamMemberId = data.teamMemberId;
    this.api.create("teams/member/invites/cancel", obj).subscribe((res) => {
      if (res.code == "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Invitation cancelled",
          showConfirmButton: false,
          timer: 2000,
        });
        this.resetPayload();
        this.getInviteList();
      }
    },err => {
      this.util.stopLoader();

     });
  }

  canShow(data, source) {
    return true;
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
}


